export const isEmptyPrimitive = (value: any) => {
  return typeof value === 'string' ? value.trim().length === 0 : !value
}
